import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShopNav = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M11.668 10.667a4.333 4.333 0 0 1 8.667 0V11h-8.667v-.333Zm-2 2.333v1.667a1 1 0 0 0 2 0V13h8.667v1.667a1 1 0 0 0 2 0V13h2.47c1.04 0 1.825.942 1.64 1.965l-1.698 9.333a1.667 1.667 0 0 1-1.64 1.369H8.893a1.667 1.667 0 0 1-1.64-1.369l-1.697-9.333A1.667 1.667 0 0 1 7.195 13h2.473Zm0-2v-.333a6.333 6.333 0 0 1 12.667 0V11h2.47a3.667 3.667 0 0 1 3.607 4.323l-1.697 9.333a3.667 3.667 0 0 1-3.607 3.01H8.892a3.667 3.667 0 0 1-3.607-3.01l-1.697-9.333A3.667 3.667 0 0 1 7.195 11h2.473Z",
		clipRule: "evenodd"
	})
});
export default SvgShopNav;
